module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/preface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note to the Paperback Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p1b",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. We begin first of all by speaking of the Lion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. On the Antelope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. On Piroboli Rocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. On the Swordfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. On the Charadrius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. On the Pelican")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. On the Owl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. On the Eagle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. On the Phoenix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. On the Hoopoe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. On the Wild Ass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. On the Viper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. On the Serpent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. On the Ant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. On the Siren and Ass-Centaur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. On the Hedgehog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. On the Ibis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. On the Fox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. On the Peridexion Tree and the Doves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX. On the Elephant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. On Amos the Prophet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXII. On the Roe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIII. On the Agate-stone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIV. On the Oyster-stone and the Pearl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXV. On the Adamant-stone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVI. On the Other Nature of the Wild Ass and the Monkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVII. On the Indian-stone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXVIII. On the Heron, that is, the Coot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXIX. On the Fig Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXX. On the Panther")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXI. On the Whale, that is, the Aspidoceleon")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXII. On the Partridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIII. On the Vulture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIV. On the Ant-lion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXV. On the Weasel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVI. On the Unicorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVII. On the Beaver")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXVIII. On the Hyena or the Brute")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XXXIX. On the Niluus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XL. On the Echinemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLI. On the Little Crow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLII. On the Ostrich")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLIII. On the Turtle-dove")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLIV. On the Swallow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLV. On the Stag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLVI. On the Frog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLVII. On the Lizard, that is, the Salamander")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLVIII. On the Magnet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XLIX. On the Adamant-stone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L. On the Doves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap1#chap1_p189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LI. On the Sun-lizard, that is, the Sun-eel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc_p54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a90703","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0